import React from 'react';
import { connect } from 'react-redux';
import { Table, Container, Row, Col, Input } from 'reactstrap';
import i18n from "../../../i18next";
import Pagination from 'react-js-pagination';

import { loadTriggerNotificationSearch } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';

class NotificationSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: '',
        page: 0,
        triggerName: '',
        triggerMethod: ''

    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;
        this.props.loadTriggerNotificationSearch(restaurantId, customerId, this.state.page, this.state.fromDate, this.state.toDate,
            this.state.triggerName, this.state.triggerMethod);
    }

    takeSearchOptionState = searchOptionState => {
        const { restaurantId, customerId } = this.props;
        this.setState({
            fromDate: searchOptionState.fromDate,
            toDate: searchOptionState.toDate,
            page: 0
        }, () => this.props.loadTriggerNotificationSearch(restaurantId, customerId, this.state.page,
            this.state.fromDate, this.state.toDate, this.state.triggerName, this.state.triggerMethod));
    }

    handlePageChange = pageNumber => {
        console.log(pageNumber)
        const { restaurantId, customerId } = this.props;
        this.setState({
            page: (pageNumber - 1)
        }, () => this.props.loadTriggerNotificationSearch(restaurantId, customerId, this.state.page,
            this.state.fromDate, this.state.toDate, this.state.triggerName, this.state.triggerMethod));
    }

    renderNotificationTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '25px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.triggerName')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.notificationMethod')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.date')}</th>
            </tr>
        );
    }

    renderTableContent = () => {
        return this.props.customerInsightNotificationSearch.content.map(item => {
            return this.renderSingleItem(item);
        })
    }

    renderSingleItem = item => {

        const { tableDetail, textCenter } = styles;

        return (
            <tr>
                <td style={{ ...tableDetail }}>{item.triggerName}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.method}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.date}</td>
            </tr>
        );
    }

    renderAdditionalSearchOptions = () => {

        return (
            <Container fluid>
                <Row>
                    {this.renderTriggerNameInput()}
                    {this.renderTriggerMethodDropdown()}
                </Row>
            </Container>
        );
    }

    renderTriggerNameInput = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="text"
                    name="triggerName"
                    id="triggerName"
                    placeholder={i18n.t('screens:customerInsightScreen.triggerName')}
                    onChange={(e) => this.setState({ triggerName: e.target.value })}
                    value={this.state.triggerName}
                />
            </ Col>
        );
    }

    renderTriggerMethodDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="triggerMethod"
                    id="triggerMethod"
                    value={this.state.triggerMethod}
                    onChange={(e) => this.setState({ triggerMethod: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectTriggerMethod')}</option>
                    <option value='1'>{i18n.t('screens:marketingAutomationScreen.email')}</option>
                    <option value='2'>{i18n.t('screens:marketingAutomationScreen.sms')}</option>
                </Input>
            </ Col>
        );
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Container>
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.customerInsightNotificationSearch.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.customerInsightNotificationSearch.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="NotificationSearch" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderAdditionalSearchOptions()}
                {this.renderNotificationTable()}
                {this.renderPagination()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightNotificationSearch: state.customerInsightNotificationSearch
    }
};

export default connect(mapStateToProps, { loadTriggerNotificationSearch })(NotificationSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/NotificationSearch.js